/**
 * utils/logger.js — wrapper peste console pentru frontend.
 *
 * - În production (`NODE_ENV === 'production'`), `info`/`debug` devin no-op.
 *   Astfel nu mai apar log-uri de debug în consola userilor/Capacitor WebView.
 * - `warn` şi `error` rămân active în toate mediile — sunt importante pentru
 *   observabilitate (Sentry prinde inclusiv console.error prin integration).
 *
 * Usage:
 *   import { logger } from './utils/logger';
 *   logger.info('[push] token refresh', token);
 *   logger.error('[audio] load error', err);
 */

const isProd = process.env.NODE_ENV === 'production';

const noop = () => {};

export const logger = {
  info: isProd ? noop : (...args) => console.log(...args),
  debug: isProd ? noop : (...args) => console.log(...args),
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
